import { Injectable } from '@angular/core';

import { Mutation, gql } from 'apollo-angular';

import { MutationAcceptSoftwareSubscriptionMasterAgreementAmendmentArgs } from '@hdms/shared/common-types';

import { ActivateSubscription, MutationActivateSubscriptionMasterAgreementAmendmentResponse } from '../constants';

@Injectable()
export class ActivateSubscriptionMasterAgreementAmendmentGqlService
  extends Mutation<
    MutationActivateSubscriptionMasterAgreementAmendmentResponse,
    MutationAcceptSoftwareSubscriptionMasterAgreementAmendmentArgs
  >
  implements ActivateSubscription
{
  override document = gql`
    mutation ActivateSoftwareSubscriptionMasterAgreementAmendment(
      $input: AcceptSoftwareSubscriptionMasterAgreementAmendmentInput!
    ) {
      acceptSoftwareSubscriptionMasterAgreementAmendment(input: $input) {
        subscriptionId
      }
    }
  `;
}
